// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iZKCd","content":"styles_content__qyNXM","tableWrap":"styles_tableWrap__3aZ6t"};